module.exports = __webpack_public_path__ + "static/img/clubempire-card-red.f8518bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-img/clubempire-card-red.png
// module id = 1687
// module chunks = 1